angular.module('gym.contacts').controller('MembershipMakeUpClassModalCtrl', ["$scope", "$modalInstance", "flash", "MakeUpClasses", "contact", "membership", "makeUpClass", function($scope, $modalInstance, flash, MakeUpClasses, contact, membership, makeUpClass) {
  var makeUpClassCopy, save;
  $scope.membership = membership;
  $scope.contact = contact;
  $scope.makeUpClass = makeUpClass;
  makeUpClassCopy = makeUpClass.id ? makeUpClass.clone() : {};
  $scope.params = {
    membership_id: membership.id,
    reason: makeUpClassCopy.reason,
    expires_on: makeUpClassCopy.expires_on,
    rootObjectName: 'makeup_class_allowance'
  };
  save = function() {
    if (makeUpClassCopy.id) {
      makeUpClassCopy.rootObjectName = 'makeup_class_allowance';
      makeUpClassCopy.reason = $scope.params.reason;
      makeUpClassCopy.expires_on = $scope.params.expires_on || null;
      return makeUpClassCopy.save();
    } else {
      return MakeUpClasses.doPOST($scope.params);
    }
  };
  $scope.submit = function() {
    $scope.loading = true;
    return save().then(function(data) {
      flash.success = "Added Successfully";
      return $modalInstance.close();
    }, function(error) {
      return $scope.loading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
